import React from 'react';
import cn from 'classnames';
import { price } from '../../utils/format';
import SvgIcon from '../../../../common/SvgIcon';

const GettingStartedDeliveryRoom = ({
  value,
  room,
  prices,
  removable = false,
  onChange,
  onRemove,
}) => {
  const selected = value[room.value] && value[room.value].term;
  const onChangePlan = function(newTermsId) {
    const p = prices[room.name] && prices[room.name].terms.find(p => p.id === newTermsId);
    p && onChange(room, p);
  };
  return (
    <div className={cn('getting-started_tag -stack', { '-active': Boolean(selected) })}>
      {removable && <span className="getting-started_tag-close" onClick={onRemove} />}

      <svg className="getting-started_tag-image">
        <use xlinkHref={`${window.roomIconsSprite || ''}#icon_room-${room.icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
      </svg>

      <div className="getting-started_tag-label">{room.label}</div>

      <div className="getting-started_tag-plan">
        <div className="getting-started_tag-plan_name">Select option</div>
        <div className="getting-started_tag-plan_options">
          {prices[room.name] &&
            prices[room.name].terms.map(plan => (
              <label className="checkbox" key={`${plan.id}`}>
                <input
                  className="checkbox_input"
                  type="radio"
                  name={`${room.value}-term`}
                  id={`${room.value}-${plan.id}`}
                  value={plan.id}
                  defaultChecked={value[room.value] && value[room.value].term === plan.id}
                  onChange={e => {
                    onChangePlan(e.target.value);
                  }}
                />
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                <span className="checkbox_label">{`${plan.name} ${price(plan.price)}`}</span>
              </label>
            ))}
        </div>
        {/*<select*/}
        {/*value={selected}*/}
        {/*className="getting-started_tag-plan_selector"*/}
        {/*onChange={e => {*/}
        {/*const p =*/}
        {/*prices[room.name] && prices[room.name].terms.find(p => p.id === e.target.value);*/}
        {/*p && onChange(room, p);*/}
        {/*}}*/}
        {/*>*/}
        {/*<option value={undefined} disabled selected>*/}
        {/*Select room delivery*/}
        {/*</option>*/}
        {/*{prices[room.name] &&*/}
        {/*prices[room.name].terms.map(plan => (*/}
        {/*<option key={`plan-${plan.id}`} value={plan.id}>*/}
        {/*{plan.name} {price(plan.price)}*/}
        {/*</option>*/}
        {/*))}*/}
        {/*</select>*/}
      </div>
    </div>
  );
};

export default GettingStartedDeliveryRoom;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedDelivery/GettingStartedDeliveryRoom.js